import { render, staticRenderFns } from "./MyCafe.vue?vue&type=template&id=d407b1ac"
import script from "./MyCafe.vue?vue&type=script&lang=js"
export * from "./MyCafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports